import { useState, useContext, useEffect } from 'react';
import { TeamsFxContext } from '../context';
import { MessageBar } from '@fluentui/react-components';
import { getLaunchUrls, getLaunchUrlParts, transformToPlanningWeb } from '../services';
import { Loader } from './Loader';
import { useTeams } from '@microsoft/teamsfx-react';
// import { app as teamsApp } from '@microsoft/teams-js';

export default function Launch() {
	const { themeString } = useContext(TeamsFxContext);
	const [teamsContext] = useTeams();
	const [redirected, setRedirected] = useState(false);

	// Setup url redirector
	const url = getLaunchUrls(themeString);

	// If the launch URL maps to a planning-web entry point, redirect there at
	// runtime; otherwise keep the original Power Apps behaviour (url.appUrl).
	const planningUrl = (() => {
		try {
			return transformToPlanningWeb(getLaunchUrlParts());
		} catch (err) {
			console.error('Launch transform failed, falling back to Power Apps URL', err);
			return null;
		}
	})();

	useEffect(() => {
		if (!planningUrl && !url?.appUrl) return;

		const doRedirect = async () => {
			const target = planningUrl ?? url.appUrl!;
			try {
				// Prefer Teams SDK context, fallback to teamsfx context
				// await teamsApp.initialize();
				// const ctx = await teamsApp.getContext();
				// const tid = ctx?.user?.tenant?.id ?? (teamsContext?.context as any)?.tid;
				// const loginHint = ctx?.user?.userPrincipalName ?? (teamsContext?.context as any)?.loginHint;

				// let redirect = target;
				// const extras: string[] = [];
				// if (tid) extras.push(`tid=${encodeURIComponent(tid)}`);
				// if (loginHint) extras.push(`login_hint=${encodeURIComponent(loginHint)}`);

				// if (extras.length) {
				// 	const [base, hash] = redirect.split('#');
				// 	const connector = base.includes('?') ? '&' : '?';
				// 	redirect = `${base}${connector}${extras.join('&')}${hash ? '#' + hash : ''}`;
				// }

				// Redirect immediately
				setRedirected(true);
				window.location.href = target;
			} catch (err) {
				console.error('Launch redirect failed, falling back to target URL', err);
				setRedirected(true);
				window.location.href = target;
			}
		};

		doRedirect();
	}, [themeString, teamsContext, planningUrl, url.appUrl]);

	if (!planningUrl && !url?.appUrl) {
		return <MessageBar intent='error'>Configuration error: Launch app URL not found.</MessageBar>;
	}

	return (
		<div className={themeString === 'default' ? 'light' : themeString === 'dark' ? 'dark' : 'contrast'}>
			<div className='launch page'>
				<div className='narrow'>
					<div className='page-centered'>
						{!redirected && <Loader />}
						{redirected && (
							<>
								<Loader />
							</>
						)}
					</div>
				</div>
			</div>
		</div>
	);
}
